<!-- eslint-disable vue/require-v-for-key -->
<template>
  <div id="three-list">
    <div class="list-menu">
      <!-- <van-nav-bar title="职责清单" safe-area-inset-top :border="false">
        <template #left>
          <van-icon name="cross" size="22" color="#FFF" @click="back"/>
        </template>
        <template #right>
          <van-icon name="ellipsis" size="22" color="#FFF" />
        </template>
      </van-nav-bar> -->
      <div class="box-container list-items">
        <div class="box flex-around">
          <template v-for="(v, k) in tabList">
            <div
              class="list-item"
              :class="index == k + 1 ? 'on' : ''"
              v-if="v.isOn == 'enable'"
              :style="{
                width:
                  100 / tabList.filter((item) => item.isOn == 'enable').length +
                  '%',
              }"
              @click="gotoDuties(v.listCode, k + 1)"
            >
              <div class="item-name">{{ v.listName }}</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="tabList">
      <component :is="componentName" :itemType="itemType"></component>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http";
import { Toast } from "vant";
import {
  queryMattersDepartments,
  queryMobileItemListsData,
  queryMobileResponsibilityData,
} from "@/api/three-list/index";
import dutiesList from "./DutiesList";
import MatterList from "./MatterList";
export default {
  name: "ThreeList",
  components: {
    ServiceItemLandscape: () => import("./components/ServiceItemLandscape"),
    dutiesList,
    MatterList,
  },
  data() {
    return {
      params: {
        orgId: "", //部门id
      },
      menus: [],
      orgArray: [],
      list: [],
      emptyShow: false,
      componentName: null,
      index: 1,
      itemType: 0,
      tabList: [],
    };
  },
  created() {
    //window.history.pushState(null, null, document.URL);
    // this.init();
    this.getTabMenu();
  },
  methods: {
    back() {
      this.$router.go(-2);
    },
    getTabMenu() {
      http.get("/nonlogin/dutyPortal/toThreeListsMainPage.htm").then((res) => {
        this.tabList = res;
        // console.log(res.filter(item => item.isOn = "enable"))
        this.index = res.findIndex((item) => item.isOn == "enable") + 1;
        this.componentName =
          res.filter((item) => item.isOn == "enable")[0].listCode == "zzqd"
            ? dutiesList
            : MatterList;
        this.itemType =
          res.filter((item) => item.isOn == "enable")[0].listCode == "zzqd"
            ? 0
            : res.filter((item) => item.isOn == "enable")[0].listCode == "fwqd"
            ? 1
            : 2;
      });
    },
    init() {
      // this.getMenus();
      // this.getDectionary();
    },
    getMenus() {
      this.menus = [];
      const keys = ["listConfig"];
      http.get("/param/keys.htm", { keys: keys.join() }).then((resp) => {
        if (!resp || resp.code != 200) {
          Toast({
            message: `获取系统参数${dictionaryKey}失败`,
            className: "zindex",
          });
        } else {
          keys.forEach((item, index) => {
            let array = [];
            if (typeof resp.data[item] == "string") {
              array = JSON.parse(resp.data[item]);
            } else {
              array = resp.data[item];
            }
            array.forEach((item) => {
              this.menus.push(item.listName);
            });
          });
        }
      });
    },
    getList() {
      this.emptyShow = false;
      this.mixinShowLoading();
      let params = {
        sxmcLike: this.params.sxmcLike,
        orgId: this.params.orgId,
        fwdxId: this.params.fwdxId,
        sxxzId: this.params.sxxzId,
        blmsId: this.params.blmsId,
        sxbhLike: this.params.sxbhLike,
      };
      queryMobileItemListsData(params).then((res) => {
        if (res.code && res.code == 200) {
          if (res.data.length > 0) {
            this.list = res.data || [];
            this.list.length > 0
              ? (this.emptyShow = false)
              : (this.emptyShow = true);
            this.mixinClearLoading();
          } else {
            queryMobileResponsibilityData({ orgId: params.orgId }).then(
              (resp) => {
                if (resp.code && resp.code == 200) {
                  this.list = resp.data;
                  this.list.length > 0
                    ? (this.emptyShow = false)
                    : (this.emptyShow = true);
                  this.mixinClearLoading();
                }
              }
            );
          }
        }
      });
    },
    gotoDuties(type, index) {
      this.index = index;
      switch (type) {
        case "zzqd":
          this.itemType = 0;
          this.componentName = dutiesList;
          break;
        case "fwqd":
          this.itemType = 1;
          this.componentName = MatterList;
          break;
        case "spqd":
          this.itemType = 2;
          this.componentName = MatterList;
          break;
      }
    },
    gotoMatter() {
      this.$router.push("/threeList/matter");
    },
    routerTo(url) {
      this.$router.push(url);
    },
    // 列表点击事件
    matterHandle(item) {
      this.$router.push({
        path: "/threeList/matter/detail",
        query: {
          id: item.ID,
        },
      });
    },
    //  获取数据字典
    getDectionary() {
      let self = this;
      const keys = [
        "listOrgType", //部门类别
      ];
      http.get("/param/keys.htm", { keys: keys.join() }).then((resp) => {
        if (!resp || resp.code != 200) {
          Toast({
            message: `获取系统参数${dictionaryKey}失败`,
            className: "zindex",
          });
        } else {
          let array = [];
          if (typeof resp.data["listOrgType"] == "string") {
            array = JSON.parse(resp.data["listOrgType"]);
          } else {
            array = resp.data["listOrgType"];
          }
          this.orgArray = array;
          array.forEach((item, index) => {
            queryMattersDepartments({ typeId: item.id }).then((res) => {
              if (res.code && res.code == 200) {
                this.$set(this.orgArray[index], "list", res.data || []);
                if (this.orgArray[index].list.length > 0) {
                  this.params.orgId = this.orgArray[index].list[0].ORGID;
                  self.getList();
                  return;
                }
              }
            });
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/css/theme/theme.scss";

.page-title,
.item-icon {
  background-color: var(--main-color);
}

#three-list {
  overflow: hidden;

  .list-menu {
    width: 100%;
    height: 60px;
    // background: #4381DE;
    background-color: var(--main-color);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;

    .list-items {
      padding: 12.5px 12.5px 0;
      box-sizing: border-box;

      .box {
        background: transparent;
        border: 1px solid #fff;

        .list-item {
          width: 33.3333%;
          height: 34px;
          text-align: center;
          line-height: 34px;
          box-sizing: border-box;

          .item-name {
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            font-size: 17.5px;
          }

          &.on {
            background: #fff;

            .item-name {
              // color: #4182db;
              color: var(--main-color);
            }
          }

          &.haveLine {
            border-right: 1px solid #fff;
            border-left: 1px solid #fff;
          }
        }
      }
    }
  }

  .tabList {
    margin-top: 60px;
    overflow: hidden;
  }
}

.page-title {
  height: 48px;
  color: #ffffff;
  font-weight: bold;
  @extend .font18;
}

.box-container {
  padding: 15px;

  .box {
    border-radius: 5px;
  }

  &.list-items {
    padding-bottom: 0;
  }
}

.list-items {
  position: relative;
  z-index: 0;

  &::after {
    content: "";
    width: 120%;
    height: 100px;
    position: absolute;
    left: -10%;
    top: 0;
    border-radius: 0 0 50% 50%;
    /*background-color: var(--main-color);*/
    z-index: 1;
  }

  .box {
    background-color: #ffffff;
    position: relative;
    z-index: 2;
  }

  .list-item {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: center;

    .item-icon {
      width: 52px;
      height: 52px;
      padding: 10px;
      border-radius: 5px;
      position: relative;
      z-index: 3;
      box-sizing: border-box;
      overflow: hidden;

      &::after {
        position: absolute;
        content: "";
        display: block;
        top: 15px;
        left: 13px;
        width: 70.71px;
        height: 70.71px;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.01),
          rgba(255, 255, 255, 0.2)
        );
        background: -webkit-linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.01),
          rgba(255, 255, 255, 0.2)
        );
        background: -moz-linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.01),
          rgba(255, 255, 255, 0.2)
        );
        background: -o-linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.01),
          rgba(255, 255, 255, 0.2)
        );
        transform: rotate(135deg);
        z-index: 4;
      }
    }

    .item-name {
      color: #333333;
      /*font-size: 5px;*/
      @extend .font16;
    }
  }
}

.empty {
  /*margin-top: 100px;*/
}

::v-deep .van-nav-bar {
  background: transparent;
  margin-top: 46px;
}

::v-deep .van-nav-bar__title {
  font-size: 17.5px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
}
</style>